'use client';
import React from 'react';
import Slider from 'react-slick';

const TechnicalApproachAIAgents: React.FC = () => {
    const technicalapproach = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1366,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study relative overflow-hidden">
                <div className="absolute inset-0 z-0">
                    <video playsInline autoPlay muted loop className="aimlvideo w-full h-full object-cover">
                        <source src="media/video-ai-agent-bg.mp4" type="video/mp4" />
                    </video>
                    {/* Gradient Overlay */}
                    <div className="absolute inset-0 pointer-events-none bg-video-gradient"></div>
                </div>
                <div className="container lg:container md:mx-auto relative z-[1]">
                    <div className="row grid lg:grid-cols-12 mb-50">
                        <div className="lg:col-span-10">
                            <h2 className="mb-2.5 text-white">
                                How We Build: <span className="gradient-text">Our Technical Approach</span>
                            </h2>
                            <p className="mb-0 fw-600 text-[#D7DEE5]">
                                We combine robust enterprise orchestration frameworks with Model Context Protocol (MCP) to deliver production-ready autonomous agents rapidly and reliably. Our approach encompasses:
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 case-study-slider-img case-study-slider-aiml technical-approach-slider aienabled-fintech-slider">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...technicalapproach} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-discovery-design bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Workflow Analysis
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Thoroughly map existing manual processes to identify automation opportunities and define clear success metrics.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-data-preparation bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Agent Architecture
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Design flexible single-agent or multi-agent systems with well-defined roles, responsibilities, and escalation pathways.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-rag-architecture bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                   MCP Integration
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Develop secure server-client connectors for ERP, CRM, and databases using OAuth and API authentication to ensure safe system interoperability.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-prompt-engineering bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Sandbox Testing
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Rigorously validate agent behavior within controlled environments, supported by human oversight and rollback mechanisms to guarantee safety.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-fine-tuning bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Production Deployment
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                    Implement phased rollouts equipped with real-time monitoring dashboards, comprehensive audit logs, and continuous learning feedback loops.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-4 md:mx-4 mx-0">
                                        <div className="card rounded-10 glass-effect-aiml">
                                            <div className="bg-integration-testing bg-cover bg-no-repeat bg-center h-[100px] rounded-t-10 flex">
                                                <p className="text-white text-2xl font-bold py-5 px-7 mb-0 flex items-center justify-center">
                                                    Governance
                                                </p>
                                            </div>
                                            <div className="p-5">
                                                <p className="text-[#D7DEE5] mb-0 fs-md min-h-[120px]">
                                                   Enforce strong human-in-loop controls, compliance tracking, and explainability features tailored for regulated industry demands.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default TechnicalApproachAIAgents;
